import modalConfirmationAddingOnCart from "./modalConfirmationAddingOnCart"
export default modalConfirmationAddingOnCart;
